<template>
    <div class="">
        <template v-if="data !== null">
            <form id="applyLeave" @submit.prevent="addLeaveData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="mt-0"> Apply for leave </h1>
                </div>
                <div class="global-main">
                    <div class="px-5 mx-5">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Select Type <em class="required">*</em></label>
                                    <select name="leave_type" id="leave_type" class="form-control selectpicker custom-select2" v-model="form.leave_type" @change="countDays($event)" :class="{ 'is-invalid': form.errors.has('leave_type') }">
                                        <option value="" selected>Select Leave Type </option>
                                        <option v-for="mlq in data.myLeaveQuota" :key="mlq.id" :data-id="mlq.id" :value="mlq.title" :balance="mlq.balance" :disabled="mlq.balance <= 0.00">{{mlq.title}} ( {{mlq.balance | formatNumber}} )</option>
                                    </select>
                                    <has-error :form="form" field="leave_type"></has-error>
                                </div>
                            </div>
                            <div class="col-md-12" v-show="form.leave_type && data.partialLeaves.length >0 ">
                                <div class="form-group">
                                    <label class="label block-label"> Partial Leave </label>
                                    <select name="partial_leave" id="partial_leave" class="form-control selectpicker custom-select2" @change="countDayOne($event)" :class="{ 'is-invalid': form.errors.has('partial_leave') }" v-model="form.partial_leave">
                                        <option value="">Select Partial Leave Type </option>
                                        <option v-for="pl in data.partialLeaves" :key="pl.id" :data-id="pl.id" :data-hours="pl.hours" :value="pl.title">{{pl.title}} ( {{pl.hours}} Hrs )</option>
                                    </select>
                                    <has-error :form="form" field="partial_leave"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6" v-show="form.leave_type">
                                <div class="form-group" :class="{ 'calendar-error': form.errors.has('from') }">
                                    <label class="label block-label"> Apply From <em class="required">*</em></label>
                                    <datepicker name="from" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Apply From" ref="datePickerFrom"  v-model="form.from" :input-class="{ 'is-invalid': form.errors.has('from') }" :selected="dateRange()"></datepicker>
<!--                                <datepicker name="from" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Apply From" ref="datePickerFrom" :disabledDates="disabledDatesFrom" v-model="form.from" :input-class="{ 'is-invalid': form.errors.has('from') }" :selected="dateRange()"></datepicker>-->
                                    <has-error :form="form" field="from"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6" v-show="form.leave_type">
                                <div class="form-group" :class="{ 'calendar-error': form.errors.has('to') }">
                                    <label class="label block-label"> Apply To <em class="required">*</em></label>
                                    <datepicker name="to" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Apply To" ref="datePickerTo"  v-model="form.to" :input-class="{ 'is-invalid': form.errors.has('to') }"></datepicker>
<!--                                <datepicker name="to" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="Apply To" ref="datePickerTo" :disabledDates="disabledDatesTo" v-model="form.to" :input-class="{ 'is-invalid': form.errors.has('to') }"></datepicker>-->
                                    <has-error :form="form" field="to"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Line Manager </label>
                                    <input type="text" class="form-control" name="line_manager" disabled :placeholder="team_manager" :class="{ 'is-invalid': form.errors.has('line_manager') }"/>
                                    <has-error :form="form" field="line_manager"></has-error>
                                </div>
                            </div> -->
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Back up / Point of contact </label>
                                    <select name="alternate_backup" class="form-control selectpicker custom-select2" v-model="form.alternate_backup" :class="{ 'is-invalid': form.errors.has('alternate_backup') }">
                                        <option value=""> Select Back up / Point of contact </option>
                                        <option v-for="depUser in data.userByDepartment" :key="depUser.id" :value="depUser.id">{{depUser.name}}</option>
                                    </select>
                                     <has-error :form="form" field="alternate_backup"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> CC (Email Addresses): </label>
                                    <div class="form-control selecttize-email" id="select_email" >
                                        <input type="text" id="select-symptom" name="cc_emails[]" v-model="form.cc_emails" placeholder="Enter Name or email">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="label block-label"> Reason <em class="required">*</em></label>
                                    <textarea class="form-control" name="description" id="description" v-model="form.description" :class="{ 'is-invalid': form.errors.has('description') }"></textarea>
                                    <has-error :form="form" field="description"></has-error>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="submit" id="submitLeaveApply" class="btn btn-default btn-block disabledOnClicked" value="Apply Leave" :disabled="form.busy">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="data === null">
            <preLoader></preLoader>
        </template>
	</div>
</template>
<script>
export default {
    data() {
        return {
            data:null,
            team_manager:[],
            dayCount:null,
            // disabledDatesFrom:{
            //     to: null,
            //     days: [],
            //     dates: [],
            // },
            // disabledDatesTo:{
            //     to: new Date(),
            //     days: [],
            //     dates: [],
            // },
            form: new Form({
                leave_type_id:'',
                leave_type:'',
                partial_leave_id:'',
                partial_leave:'',
                from:'',
                to:'',
                // line_manager:[],
                alternate_backup:'',
                cc_emails:[],
                description:'',
                partial_leave_duration:''
            }),
            userByDepartment: [],
            options:[],
        };
    },

    filters: {
        formatNumber: function(num){
            return parseFloat(num).toFixed(2);
        }
    },

    mounted() {
        var dt = new Date();
        dt.setDate( dt.getDate() - 1 );
        // this.disabledDatesFrom.to =  dt;
        this.getLeaveQouta();
    },

    updated(){
        // this.disabledDatesTo.to = this.form.from;
    },

    methods: {
        addLeaveData(){
            this.form.partial_leave_duration =  $('#partial_leave').find(':selected').attr('data-hours');
            this.form.partial_leave_id =  $('#partial_leave').find(':selected').attr('data-id');
            this.form.leave_type_id =  $('#leave_type').find(':selected').attr('data-id');
            this.$Progress.start();
                this.form.post('api/applyLeave')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 'error'){
                            this.showAlertBox('error',res.data.msg);
                            return
                        }else{
                            this.showToastBox('success', 'Leave applied successfully');
                        }
                        this.$Progress.finish();
                        this.$router.push('/leaves');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }

                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
        },

        dateRange(){
            var dayCount = (this.dayCount)-1; //subract 1 due to correct days
            Date.prototype.addDays = function(days){
                if(dayCount == 0){
                    this.setDate(this.getDate());
                }else{
                    this.setDate(this.getDate() + parseInt(dayCount));
                }
                return this;
            }
            var date = new Date(this.form.from);
            // this.disabledDatesTo.from = date.addDays(dayCount);
        },

        clearDates(){
            this.$refs.datePickerFrom.clearDate();
            this.$refs.datePickerTo.clearDate();
        },

        countDayOne: function(e){
            var value = e.target.value;
            if(value == "" || value == null){
                this.countDays();
                this.dateRange();
            }else{
                this.dayCount = 1;
            }
            this.clearDates(); // this is used to clear dates when user change leave types
        },

        countDays: function(e){
            var dayCount = $('#leave_type').find(':selected').attr('balance');
            this.dayCount = dayCount;
            this.clearDates(); // this is used to clear dates when user change leave types
        },

        getLeaveQouta(){
            let that = this;
            axios.get('/api/applyLeave')
            .then(res => {
                this.data = res.data.data;
                //code for disabling the Holiday dates
                // that.disabledDatesFrom.days = [];
                // that.disabledDatesTo.days = [];
                var str = res.data.data.companySetting.off_days;
                if(str !== null){
                    var obj = JSON.parse(str);
                    // Object.keys(obj).forEach(function(key) {
                    //     //code for disabled company holidays week days
                    //     if(obj[key] == "Sunday"){
                    //         that.disabledDatesFrom.days.push(0);
                    //         that.disabledDatesTo.days.push(0);
                    //     }else if(obj[key] == "Monday"){
                    //         that.disabledDatesFrom.days.push(1);
                    //         that.disabledDatesTo.days.push(1);
                    //     }else if(obj[key] == "Tuesday"){
                    //         that.disabledDatesFrom.days.push(2);
                    //         that.disabledDatesTo.days.push(2);
                    //     }else if(obj[key] == "Wednesday"){
                    //         that.disabledDatesFrom.days.push(3);
                    //         that.disabledDatesTo.days.push(3);
                    //     }else if(obj[key] == "Thursday"){
                    //         that.disabledDatesFrom.days.push(4);
                    //         that.disabledDatesTo.days.push(4);
                    //     }else if(obj[key] == "Friday"){
                    //         that.disabledDatesFrom.days.push(5);
                    //         that.disabledDatesTo.days.push(5);
                    //     }else if(obj[key] == "Saturday"){
                    //         that.disabledDatesFrom.days.push(6);
                    //         that.disabledDatesTo.days.push(6);
                    //     }
                    // });
                }//end-if
                //disabled holiday dates
                // that.disabledDatesFrom.dates = [];
                // that.disabledDatesTo.dates = [];
                // code for disable holiday dates on calender
                var holidayDates = res.data.data.companyHolidays;
                // if(holidayDates !== null){
                //     var obj = holidayDates;
                //     Object.keys(obj).forEach(function(key) {
                //         var date = obj[key].holiday;
                //         var day = new Date(date);
                //         // that.disabledDatesFrom.dates.push(day);
                //         // that.disabledDatesTo.dates.push(day);
                //     });
                // }
                // var tm = res.data.data.teamManager;
                // if(tm.length > 0){
                //     tm.forEach(e => {
                //         this.form.line_manager.push(e.id);
                //         this.team_manager.push(e.name);
                //     });
                // }else{
                //     this.form.line_manager = this.team_manager = '--';
                // }
                /* THIS CODE IS FOR EMAILS SYMPTOM PLUGIN */
                var cc_emails = res.data.data.cc_emails;
                cc_emails.forEach(e => {
                    var obj = {id: e.email, type: 'hand', symptom: e.name+ ' - ' + e.email}
                    this.options.push(obj);
                });


            }).then(res =>{
                $('.selectpicker').selectpicker('refresh');
                this.selectizeMethod();
            })
            .catch(err => {
                console.log(err);
            });
        },

        selectizeMethod(){
            let that = this;
            $("#select-symptom").selectize({
                options: that.options,
                optgroups: [
                    { id: 'emails', name: 'Emails'}
                ],
                labelField: 'symptom',
                valueField: 'id',
                optgroupField: 'type',
                optgroupLabelField: 'name',
                optgroupValueField: 'id',
                //  optgroupOrder: ['dental', 'cardiovascular'],
                optgroupOrder: ['left-hand', 'right-hand'],
                searchField: ['symptom'],
                //plugins: ['optgroup_columns'],
                create: false,
                sortField: 'text',
                onChange : function(e){
                    that.form.cc_emails = e;
                }
            });
        }
    },
}
</script>
